import http from "./httpService";

const apiEndpointRegister = "register";
const apiEndpointReset = "reset";

export function register(user) {
    return http.post(apiEndpointRegister, {
        username: user.username,
        password: user.password,
        email: user.email,
        user_type: user.user_type
    });
}

export function forgotPassword(email) {
    return http.post(apiEndpointReset, {
        email: email
    });
}

export function resetPassword(token, password) {
    return http.post(apiEndpointReset + '/' + token, {
        password: password
    });
}